<template>
  <div id="app" tabindex="-1">
    <base-loading :is-active="isLoading" is-overlay />

    <transition name="fade-transition" mode="out-in">
      <component :is="layout" v-if="!isLoading">
        <transition name="fade-transition" mode="out-in">
          <keep-alive include="Dashboard">
            <router-view :key="$route.fullPath" />
          </keep-alive>
        </transition>
      </component>
    </transition>
  </div>
</template>

<script>
import { debounce, throttle } from 'lodash'

import { context, event } from '@/mixins/helpers'

import { Default, Editor, Simple } from '@/layouts'

const lockoutPeriodExpired = debounce(func => func(), 900000) // 15 minutes

export default {
  name: 'app',

  components: {
    'default-layout': Default,
    'editor-layout': Editor,
    'simple-layout': Simple
  },

  data () {
    return {
      isLoading: false
    }
  },

  mixins: [context, event],

  mounted () {
    this.$watch(() => this.isAuthorized, isAuthorized => {
      this.setEventListeners(isAuthorized)

      if (isAuthorized) {
        this.$store.dispatch('getUserNotificationStatus').then(({ notification, totalUnreadCount = 0, passwordExpiresInXDays = 0 } = {}) => {
          if (totalUnreadCount > 0) {
            this.$store.dispatch('showMessage', { title: this.$i18n.t('sentence.notification{label}', { label: notification.title }), route: { name: 'notificationDetail', params: { reference: notification.reference } }, options: { variant: 'info' } })
          }
          if (passwordExpiresInXDays > 0 && passwordExpiresInXDays < 8) {
            this.$store.dispatch('showMessage', { title: this.$i18n.t('sentence.passwordExpiresIn{days}', { days: passwordExpiresInXDays }), autoHideDelay: 5000, options: { variant: 'danger' } })
          }
        })

        if (this.$store.getters.isContextSelected()) {
          this.isLoading = true

          const { policy } = this.$store.state.authorization

          const actions = [{
            type: 'getPermissions',
            isEnabled: () => true
          }, {
            type: 'getBusiness',
            isEnabled: () => this.context.isSelected('business') && policy.hasAnyBusinessRole(this.context)
          }, {
            type: 'getMerchant',
            isEnabled: () => this.context.isSelected('merchant')
          }]

          actions.reduce((promise, action) => promise.then(() => action.isEnabled() ? this.$store.dispatch(action.type, this.context) : Promise.resolve()), Promise.resolve()).then(() => {
            this.$eventHub.$emit('updateMenuItems')

            this.isLoading = false
          })
        }
      }
    }, { immediate: true })
  },

  computed: {
    layout () {
      return `${typeof this.$route.meta.layout !== 'undefined' ? this.$route.meta.layout : this.isAuthorized ? 'default' : 'simple'}-layout`
    },

    isAuthorized () {
      return this.$store.getters.isAuthorized()
    }
  },

  methods: {
    setEventListeners (isAuthorized) {
      if (isAuthorized) {
        this.resetLockoutPeriod()
      }

      const events = [{ name: 'click', handler: throttle(this.resetLockoutPeriod, 500) }, { name: 'mousemove', handler: throttle(this.resetLockoutPeriod, 1000) }]
      events.forEach(event => isAuthorized ? this.addEventListener(event) : this.removeEventListener(event))
    },

    resetLockoutPeriod () {
      lockoutPeriodExpired(() => {
        this.$router.push({ name: 'signOut' })
      })
    }
  }
}
</script>
